import * as i0 from '@angular/core';
import * as i1 from './ngxcreditcard.module';
import * as i2 from './directives/cc-number-format.directive';
import * as i3 from './directives/cc-expiry-format.directive';
import * as i4 from './directives/cc-cvc-format.directive';
export const NgXCreditCardsModuleNgFactory:i0.NgModuleFactory<i1.NgXCreditCardsModule> = (null as any);
var _decl0_0:i2.CCNumberFormatDirective = (<any>(null as any));
var _decl0_1:i3.CCExpiryFormatDirective = (<any>(null as any));
var _decl0_2:i4.CCCvcFormatDirective = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
